// Generated by Melange

import * as React from "react";

const initValue_0 = {
  NAME: "Data",
  VAL: {
    id: "",
    schema: "",
    profile: undefined,
    create_time: undefined,
    tenants: /* [] */ 0
  }
};

function initValue_1(tenant, param) {
  
}

const initValue = [
  initValue_0,
  initValue_1
];

const context = React.createContext(initValue);

function use(param) {
  return React.useContext(context);
}

const make = context.Provider;

function makeProps(value, children, param) {
  return {
    value: value,
    children: children
  };
}

const Provider = {
  make: make,
  makeProps: makeProps
};

export {
  initValue,
  context,
  use,
  Provider,
}
/* context Not a pure module */
